<template>

  <div class="wrapper__inner">

    <div 
      :style="'background-image: url('+image+')'"
      class="content content__background-image"
    ></div>

  </div>

</template>

<script>

  export default {
    name: 'SectionBackgroundImage',
    props: {
      image: {
        type: String,
        required: true,
        default: () => {}
      }
    }
  };
</script>